import { createReducer } from '@reduxjs/toolkit';
import {
  setPermissionState,
  dismissBanner,
  resetBannerDismissed,
} from 'actions/redux/local_network_access_actions';

const INITIAL_STATE = {
  permissionState: 'unknown',
  bannerDismissed: false,
};

const LocalNetworkAccessReducer = createReducer(INITIAL_STATE, {
  [setPermissionState]: (state, action) => {
    state.permissionState = action.payload;
  },
  [dismissBanner]: (state) => {
    state.bannerDismissed = true;
  },
  [resetBannerDismissed]: (state) => {
    state.bannerDismissed = false;
  },
});

export default LocalNetworkAccessReducer;
